module.exports = __webpack_public_path__ + "media/images/favicon_48x48-1aec230e33e6ca5135f7ba462ca71e16.png";